export enum PosVendor {
  /**
   * Carrols (a.k.a. Xenial)
   */
  CARROLS = 'CARROLS',
  /**
   * IMPORTANT: DO NOT USE THE "CONNECTOR" PosVendor!
   *
   * The "Connector" POS is represented as "PRODUCT_NUMBER."
   */
  CONNECTOR = 'CONNECTOR',
  /**
   * National Cash Register (NCR) / and NCR Enterprise Platform (NEP)
   */
  NCR = 'NCR',
  /**
   * Oracle Hospitality eCommerce Integration Cloud Service
   * also known as Oracle
   * also know as Micros
   */
  OHEICS = 'OHEICS',
  /**
   * Used for Partner API to allow 3rd parties to integrate with us
   */
  PARTNER = 'PARTNER',
  /**
   * Tim Horton's Connector (a.k.a Product Number)
   */
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  /**
   * rPOS / RBI POS (f.k.a. MediaWorks)
   */
  RPOS = 'RPOS',
  SIMPLY_DELIVERY = 'SIMPLY_DELIVERY',
  QDI = 'QDI',
  QST = 'QST',
  SICOM = 'SICOM',
  TABLET = 'TABLET',
}
